module.exports = __webpack_public_path__ + "static/media/message-circle-icon.95b3e598.svg";